import { createContext } from "react";

export const OpenDrawerContext = createContext("");
